import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import BenefitTile from './benefit-tile';
import { SectionHeading } from './benefit-tile.styled';
import { BenefitsContainer, HighlevelBenefitsContainer } from './highlevelBenefits.styled';

export function HighlevelBenefits({ config }) {
  return (
    <WidthContainer>
      <HighlevelBenefitsContainer>
        <SectionHeading>Why join Pata?</SectionHeading>

        <BenefitsContainer>
          {config.map((tile) => (
            <BenefitTile key={tile.id} benefit={tile} />
          ))}
        </BenefitsContainer>
      </HighlevelBenefitsContainer>
    </WidthContainer>
  );
}
